// src/Informes/Components/Charts.js
import React from "react";
import { Fade, Grid } from "@mui/material";
import { LineChart } from "@mui/x-charts/LineChart";
import { PieChart } from "@mui/x-charts/PieChart";
import { LinearProgress } from "@mui/material";
import { ItemList } from "./Items";

export const CasesLineChart = ({ casesGraph }) => (
  <Grid
    item
    xs={12}
    sx={{
      width: "100%",
      padding: "10px",
    }}
  >
    <div className="dashboardContainers">
      <h3>Expedientes por meses</h3>
      <hr className="fullDividerClass"></hr>
      <LineChart
        dataset={casesGraph}
        xAxis={[
          {
            id: "Years",
            dataKey: "date",
            scaleType: "point",
            valueFormatter: (date) => date.toString(),
          },
        ]}
        series={[
          {
            id: "Numero",
            label: "Numero de expedientes ",
            dataKey: "count",
            stack: "total",
            showMark: false,
          },
        ]}
        style={{ width: "100%" }}
        height={500}
      />
    </div>
  </Grid>
);

export const CasesPieCharts = ({ casesStatusData, flag6 }) => {
  return (
    <Grid
      item
      xs={12}
      sx={{
        width: "100%",
        padding: "10px",
      }}
    >
      {/* <hr className="fullDividerClass"></hr> */}
      {/* <h4>Todas las Categorías</h4> */}
      {/* <hr className="dividerClass"></hr> */}
      {/* {flag6 && <LinearProgress color="success" />} */}
      <Fade timeout={600} in>
        <div className="dashboardContainers">
          <h3>Expedientes por estado</h3>
          <hr className="fullDividerClass"></hr>
          <PieChart
            series={[
              {
                data: casesStatusData,
                innerRadius: 30,
                outerRadius: "100%",
                paddingAngle: 5,
                cornerRadius: 5,
                startAngle: -45,
                endAngle: 225,
                cx: "57%",
                cy: 155,
                label: {
                  position: "outside",
                  formatter: (item) =>
                    `${item.case_type_name} ${item.full_case_status_name} ${item.value}%`,
                  style: { fontSize: 10 },
                },
                valueFormatter: (item) => `${item.value}%`,
              },
            ]}
            height={310}
            slotProps={{
              legend: { hidden: true },
              tooltip: {
                itemContent: (item) => (
                  <div style={{ fontSize: "12px" }}>
                    <strong>{item.case_type_name}</strong>
                    {item.full_case_status_name} {item.value}%
                  </div>
                ),
              },
            }}
          />
          <div
            style={{
              display: "grid",
              gap: "5px", // fila x columna
              marginTop: "30px",
            }}
          >
            {casesStatusData?.map((item) => (
              <div
                key={`${item.case_type_name} ${item.full_case_status_name} ${item.value}%`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "2px",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    backgroundColor: item.color,
                    display: "inline-block",
                    borderRadius: "50%",
                  }}
                />
                <span>{`${item.case_type_name} ${item.full_case_status_name}`}</span>{" "}
                <b>{`${item.value}%`}</b>
              </div>
            ))}
          </div>
        </div>

        {/* <Grid item xs={12} textAlign={"center"}>
      <hr className="bigDividerClass"></hr>
      <h4>Categoría Otros</h4>
      <hr className="dividerClass"></hr>
      <PieChart
        series={[{ data: otherCasesStatus, innerRadius: 60, outerRadius: 200, paddingAngle: 2, cornerRadius: 5, cx: "60%",
          label: { position: "outside", formatter: (item) => `Otros - ${item.label}: ${item.value}%`, style: { fontSize: "10px" } },
          valueFormatter: (item) => `${item.value}%` }]}
        height={400}
        width={600}
        style={{ margin: "auto" }}
        slotProps={{ legend: { hidden: true } }}
      />
    </Grid>

    <Grid item xs={12} mt={5}>
      <ItemList items={otherCasesStatus} />
    </Grid> */}
      </Fade>
    </Grid>
  );
};
